import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { InputRequiredDirective } from './directives/input-required.directive';
import { RemoteInverseValidator } from './directives/remote-inverse-validator.directive';
import { RemoteValidator } from './directives/remote-validator.directive';
import { itcoreService } from './services/itcore.service';
const DIRECTIVES = [RemoteValidator, RemoteInverseValidator, InputRequiredDirective];

const COMPONENTS = [];

const SERVICES = [itcoreService];

@NgModule({
  imports: [CommonModule, FormsModule],
  declarations: [...DIRECTIVES, ...COMPONENTS],
  providers: [...SERVICES],
  exports: [...COMPONENTS],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
// tslint:disable-next-line: class-name
export class itcoreModule {}
